import {Component, OnInit} from '@angular/core';
import {UserService} from '../user.service';
import {LayoutService} from '../../layout/layout.service';

@Component({

  selector: 'sa-login-info',
  templateUrl: './login-info.component.html',
})
export class LoginInfoComponent implements OnInit {

  user: any;

  constructor(private userService: UserService,
              private layoutService: LayoutService) {
  }

  ngOnInit() {
    this.userService.getLoginInfo().subscribe(user => {
      // console.log(typeof user);
      // console.log(user);
      this.user = user
    })

  }

  /**
   * Unused
   * @shine
   * 2017/12/28
   */
  toggleShortcut() {
    this.layoutService.onShortcutToggle()
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/user/login-info/login-info.component.ts